import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, sendEmailVerification, sendPasswordResetEmail, onAuthStateChanged } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyAq_kQ9NhRKd-J5b-Hb4H5syb6PropjK5Y",
    authDomain: "workpulse-69d5b.firebaseapp.com",
    projectId: "workpulse-69d5b",
    storageBucket: "workpulse-69d5b.appspot.com",
    messagingSenderId: "92853486993",
    appId: "1:92853486993:web:851bcff3909363e51ac630",
    measurementId: "G-3DHPLN473Q"
};

// ✅ Check if Firebase is already initialized
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);


// ✅ Add Analytics initialization
let analytics;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
  logEvent(analytics, "app_initialized");
}

// Function to send email verification
const sendVerificationEmail = async (user) => {
  try {
    await sendEmailVerification(user);
    console.log("Verification email sent");
  } catch (error) {
    console.error("Error sending verification email:", error);
  }
};

// Function to handle password reset
const resetUserPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    console.log("Password reset email sent");
  } catch (error) {
    console.error("Error sending password reset email:", error);
  }
};

// Authentication state observer
onAuthStateChanged(auth, (user) => {
  if (user) {
    console.log("User logged in:", user.email);
  } else {
    console.log("User logged out");
  }
});

export { app, db, auth, storage, analytics, sendVerificationEmail, resetUserPassword };
